import { useEffect, useState } from "react";

import { createPortal } from "react-dom";

import {

  obtenerPreviewNasCache,

  prefetchNasPreview,

  parseNasPreviewError,

} from "../../utils/nasPreviewCache";

import { nombreDocumentoLegible } from "../../utils/gestionVentasQuickReplies";



function esWordPreview(fileName) {

  return /\.(docx?|dotx?)$/i.test(fileName || "");

}



function previewKind(mime, fileName) {

  const m = (mime || "").toLowerCase();

  if (m.startsWith("image/")) return "image";

  if (m === "application/pdf") return "pdf";

  const low = (fileName || "").toLowerCase();

  if (low.endsWith(".pdf")) return "pdf";

  if (/\.(jpe?g|png|gif|webp)$/i.test(low)) return "image";

  if (esWordPreview(low)) return "pdf";

  return "other";

}



function IconoLupa({ size = 14 }) {

  return (

    <svg

      xmlns="http://www.w3.org/2000/svg"

      width={size}

      height={size}

      viewBox="0 0 24 24"

      fill="none"

      stroke="currentColor"

      strokeWidth="2.2"

      strokeLinecap="round"

      strokeLinejoin="round"

      aria-hidden

    >

      <circle cx="11" cy="11" r="8" />

      <path d="m21 21-4.35-4.35" />

    </svg>

  );

}



export { IconoLupa, previewKind, prefetchNasPreview };



export default function ModalVistaPreviaDocumentoNas({

  isOpen,

  onClose,

  expedienteId,

  nombreArchivo,

  isDark,

  tx,

}) {

  const [cargando, setCargando] = useState(false);

  const [error, setError] = useState("");

  const [blobUrl, setBlobUrl] = useState("");

  const [mime, setMime] = useState("");



  useEffect(() => {

    if (!isOpen || !expedienteId || !nombreArchivo) {

      setBlobUrl("");

      setMime("");

      setError("");

      setCargando(false);

      return undefined;

    }



    let cancelado = false;

    const cached = obtenerPreviewNasCache(expedienteId, nombreArchivo);

    if (cached) {

      setMime(cached.mime);

      setBlobUrl(cached.blobUrl);

      setError("");

      setCargando(false);

      return undefined;

    }



    setCargando(true);

    setError("");

    setBlobUrl("");

    setMime("");



    prefetchNasPreview(expedienteId, nombreArchivo)

      .then(({ blobUrl: url, mime: ct }) => {

        if (cancelado) return;

        setMime(ct);

        setBlobUrl(url);

      })

      .catch(async (e) => {

        if (cancelado) return;

        setError(await parseNasPreviewError(e));

      })

      .finally(() => {

        if (!cancelado) setCargando(false);

      });



    return () => {

      cancelado = true;

    };

  }, [isOpen, expedienteId, nombreArchivo]);



  if (!isOpen) return null;



  const pk = previewKind(mime, nombreArchivo);

  const titulo = nombreDocumentoLegible(nombreArchivo);



  return createPortal(

    <div

      style={{

        position: "fixed",

        inset: 0,

        zIndex: 12000,

        background: "rgba(0,0,0,0.72)",

        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        padding: 12,

        fontFamily: "inherit",

      }}

      onMouseDown={(e) => { if (e.target === e.currentTarget && !cargando) onClose?.(); }}

      role="dialog"

      aria-modal="true"

      aria-label={`Vista previa: ${titulo}`}

    >

      <div

        style={{

          width: "min(96vw, 1100px)",

          height: "min(92vh, 860px)",

          display: "flex",

          flexDirection: "column",

          borderRadius: 10,

          overflow: "hidden",

          background: isDark ? "#1e2330" : "#fff",

          border: `1px solid ${isDark ? "#4a5568" : "#cbd5e1"}`,

          boxShadow: "0 20px 60px rgba(0,0,0,0.45)",

          color: tx,

        }}

        onMouseDown={(e) => e.stopPropagation()}

      >

        <div style={{

          display: "flex",

          alignItems: "center",

          justifyContent: "space-between",

          gap: 8,

          padding: "8px 12px",

          borderBottom: `1px solid ${isDark ? "#374151" : "#e5e7eb"}`,

          background: isDark ? "#252b3a" : "#f8fafc",

          flexShrink: 0,

        }}

        >

          <span style={{ fontSize: 13, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={nombreArchivo}>

            {titulo}

          </span>

          <button

            type="button"

            onClick={onClose}

            style={{

              flexShrink: 0,

              padding: "4px 12px",

              borderRadius: 5,

              border: "none",

              cursor: "pointer",

              background: isDark ? "#374151" : "#e5e7eb",

              color: tx,

              fontWeight: 700,

              fontSize: 12,

            }}

          >

            Cerrar

          </button>

        </div>

        <div style={{

          flex: 1,

          minHeight: 0,

          display: "flex",

          alignItems: "center",

          justifyContent: "center",

          padding: 8,

          background: isDark ? "#141820" : "#f1f5f9",

        }}

        >

          {cargando && (

            <div style={{ fontSize: 13, opacity: 0.8, textAlign: "center", padding: 16 }}>

              {esWordPreview(nombreArchivo)

                ? "Generando vista previa del Word…"

                : "Cargando documento…"}

            </div>

          )}

          {!cargando && error && (

            <div style={{ fontSize: 13, color: "#ef4444", textAlign: "center", padding: 16 }}>{error}</div>

          )}

          {!cargando && !error && blobUrl && pk === "image" && (

            <img

              src={blobUrl}

              alt=""

              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: 4 }}

            />

          )}

          {!cargando && !error && blobUrl && pk === "pdf" && (

            <iframe

              title={`PDF ${titulo}`}

              src={blobUrl}

              style={{

                width: "100%",

                height: "100%",

                border: `1px solid ${isDark ? "#374151" : "#cbd5e1"}`,

                borderRadius: 4,

                background: "#fff",

              }}

            />

          )}

          {!cargando && !error && blobUrl && pk === "other" && (

            <div style={{ textAlign: "center", padding: 20 }}>

              <p style={{ fontSize: 13, marginBottom: 12, opacity: 0.85 }}>

                No hay vista previa integrada para este formato.

              </p>

              <a

                href={blobUrl}

                download={nombreArchivo}

                style={{

                  display: "inline-block",

                  padding: "8px 16px",

                  borderRadius: 6,

                  background: "#2563eb",

                  color: "#fff",

                  fontWeight: 700,

                  fontSize: 13,

                  textDecoration: "none",

                }}

              >

                Descargar

              </a>

            </div>

          )}

        </div>

      </div>

    </div>,

    document.body,

  );

}


